import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { GridColumn } from '../models/grid-definition.model';
import { LookupPipe } from './lookup.pipe';

@Pipe({
  name: 'dateTime',
  standalone: true,
})
export class DateTimePipe implements PipeTransform {
  private _datePipe = inject(DatePipe);

  private _lookupPipe: LookupPipe = new LookupPipe();

  constructor() {}

  transform(dataItem: any, column: GridColumn): string {
    const value = this._lookupPipe.transform(dataItem, column);

    if (!value) return null;
    return this._datePipe.transform(value, this.getDateFormat(column));
  }

  private getDateFormat(column: GridColumn): string {
    const isDateOnlyColumn = column.type == 'date';
    switch (column.dateTimeFormatType) {
      case 'custom':
        return column.dateTimeFormat;
      case 'long':
        return isDateOnlyColumn ? 'longDate' : 'long';
      case 'short':
      default:
        return isDateOnlyColumn ? 'shortDate' : 'short';
    }
  }
}
